import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router";
import { useState } from "react";

import { createQueryClient } from "./api/queries";
import { IconSprite } from "./components/Icons";
import { DeviceApproval } from "./routes/DeviceApproval";
import { Login } from "./routes/Login";
import { NotFound } from "./routes/NotFound";
import { Dashboard, RepositorySetup } from "./routes/Dashboard";
import { Plans } from "./routes/Plans";
import { Shell } from "./routes/Shell";

export function App() {
  // Created in state, not at module scope: a module-level client is shared
  // across every render of the tree, which breaks tests that mount the app
  // twice and would leak one test's cache into the next.
  const [queryClient] = useState(createQueryClient);

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <IconSprite />
        <Routes>
          {/* Public. Everything else is nested under Shell, which is where
              the session check lives. */}
          <Route path="/login" element={<Login />} />

          <Route element={<Shell />}>
            <Route index element={<Dashboard />} />
            <Route path="/repositories/new" element={<RepositorySetup />} />
            {/* The link `berbench upload` prints. The repository id is in the
                path so that URL is a real address for one repository's
                dashboard, rather than "whichever the picker defaults to". */}
            <Route path="/repositories/:repositoryID" element={<Dashboard />} />
            {/* The CLI approval screen is inside Shell, so an unauthenticated
                visitor is sent to sign in and returned here with the code
                still in the URL. That round trip is the normal path: the CLI
                opens this link on a machine that may have no session yet. */}
            <Route path="/cli" element={<DeviceApproval />} />
            {/* Inside Shell, so a signed-out visitor is sent to sign in and
                returned here. That is right even though the page sells
                nothing: the CTA records an intent against a workspace, and an
                intent from nobody in particular is not a signal. */}
            <Route path="/plans" element={<Plans />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
